export var SEND_FEEDBACK_BUTTON_TEXT = 'Отправить';
export var NEXT_BUTTON_TEXT = 'Далее';
export var WRITE_MESSAGE_BUTTON_TEXT = 'Написать сообщение';